// import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects'
// import { urls } from '../../routing'
// import { AuthenticationService, LiteralsService } from '../../services'
// import {
//   setIsSigningUpAction,
//   setNotificationAction,
//   signUpFailedAction,
//   signUpSuccessfulAction
// } from '../actions'
// import { ISignUpState, IStoreState } from '../states'
// import { SignUpTypeKeys } from '../types'

// // Worker Saga
// function* fetchSignUpAsync() : any {
//   const routerHistory = yield getContext('routerHistory')

//   try {
//     yield put(setIsSigningUpAction())
//     const signUp: ISignUpState = yield select(
//       (state: IStoreState) => state.signUp
//     )
//     yield call(AuthenticationService.signUp, { ...signUp })
//     yield call(routerHistory.push, urls.signUpStep1)
//     // yield call(reset, routes.signUpStep1.routeName)
//     yield put(signUpSuccessfulAction())
//     yield put(
//       setNotificationAction({
//         isError: false,
//         label: LiteralsService.get('verificationCodeSent', true)
//       })
//     )
//     yield call(routerHistory.push, urls.accountVerificationStep)
//   } catch (error) {
//     yield put(
//       setNotificationAction({
//         isError: true,
//         label: LiteralsService.get(error.code, true)
//       })
//     )
//     yield put(signUpFailedAction(error))
//   }
// }

// // Watcher Saga:
// function* watchFetchSignUpAsync() {
//   yield takeLatest(SignUpTypeKeys.SIGN_UP, fetchSignUpAsync)
// }

// // single entry point to start all Sagas at once
// export default function* rootSaga() {
//   yield all([
//     watchFetchSignUpAsync()
//   ])
// }

import { all, call, put, takeLatest } from 'redux-saga/effects'
import literalsService from '../../services/literals-service'
import { UserService, AuthenticationService } from '../../services'
import {
  clearSignInFieldsAction,
  setIsLoadingUnsubscribeAction,
  setNotificationAction,
  setUnsubscribeReasonsAction,
  setUserInfoAction
} from '../actions'
import { initialUserInfoState } from '../reducers/user-info'
import { UnsubscribeTypeKeys } from '../types'
import { LeaveReasons } from '../../models/leave-reasons'
import { IBase } from '../../models'

// Worker Saga
function* fetchReasonsAsync(): any {
  try {
    yield put(setIsLoadingUnsubscribeAction(true))
    let leaveReasons = Object.values(LeaveReasons) as string[];
    leaveReasons = leaveReasons.splice(0, (leaveReasons.length/2)) as string[]
    const data: any = leaveReasons.map((key, index) => {
      return { id: index, name: literalsService.get(key.toLowerCase(), true) }
    })
    const reasons = data as IBase[]
    yield put(setUnsubscribeReasonsAction(reasons))
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: literalsService.get('serverError', true)
      })
    )
  } finally {
    yield put(setIsLoadingUnsubscribeAction(false))
  }
}

function* unsubscribeAsync(action: any) {
  try {
    yield put(setIsLoadingUnsubscribeAction(true))
    yield call(UserService.deleteUser, action.payload)
    yield call(AuthenticationService.signOut)
    yield put(clearSignInFieldsAction())
    yield put(setUserInfoAction(initialUserInfoState))
    //yield call(navigate, routes.welcome.routeName)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: literalsService.get('serverError', true)
      })
    )
  } finally {
    yield put(setIsLoadingUnsubscribeAction(false))
  }
}

// Watcher Saga:
function* watchFetchUnsubscribeReasonsAsync() {
  yield takeLatest(UnsubscribeTypeKeys.FETCH_UNSUBSCRIBE_REASONS, fetchReasonsAsync)
}

function* watchUnsubscribeAsync() {
  yield takeLatest(UnsubscribeTypeKeys.UNSUBSCRIBE, unsubscribeAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([watchFetchUnsubscribeReasonsAsync(), watchUnsubscribeAsync()])
}
